import React, {useCallback} from 'react';
import {GatewayGetSchema} from '../../../../../api/DBSchema/Gateway';
import {useTranslation} from 'react-i18next';
import PlanEditorInnerContainer from '../../../../../components/Editor/PlanEditorInnerContainer';
import Separator from '../../../../../components/Simple/Sepperator';
import SMCTextInput from '../../../../../components/Simple/SMCTextInput';
import Indentation from '../../../../../components/Simple/Indentation';
import SMCNumberInput from '../../../../../components/Simple/SMCNumberInput';
import EditorLayout from '../../../../../components/Layouts/EditorLayout';
import {SMCToggleSwitch} from "../../../../../components/Simple/SMCToggleSwitch";

const pageSchema = GatewayGetSchema.pages.ntp;
const pageId = pageSchema.pageId;

function BaseNtp({
    pageData,
    setObjectData,
    pageDisabled,
    errors
}) {
    const { t } = useTranslation();

    const managedInSmp       = pageData[pageSchema.manageInSmp];
    const primaryNtpServer   = pageData[pageSchema.primaryNtpServer];
    const secondaryNtpServer = pageData[pageSchema.secondaryNtpServer];
    const updateInterval     = pageData[pageSchema.updateIntervalMinutes];
    const isNTPAuth          = pageData[pageSchema.ntpAuthentication];
    const sharedSecret       = pageData[pageSchema.sharedSecret];
    const sharedSecretId     = pageData[pageSchema.sharedSecretIdentifier];

    const setPageValue = useCallback((param, newValue) => {
        if (!pageDisabled) {
            setObjectData([pageId, param], newValue);
        }
    }, [setObjectData, pageDisabled]);

    return (
        <EditorLayout>
            <SMCToggleSwitch
                disabled={pageDisabled}
                checked={managedInSmp}
                // error={errors[pageSchema.manageInSmp]}
                onChange={checked => setPageValue(pageSchema.manageInSmp, checked)}
                label={t('SMP.PLAN.MANAGE_IN_SMP')}
            />
            <Separator isMainSeparator/>
            <PlanEditorInnerContainer title={t('SMP.GATEWAYS.INNER_MENU.NTP')} managedInSmp={managedInSmp}>
                {/* Primary NTP server */}
                <SMCTextInput
                    label={t('SMP.PLAN.NEW_PLAN_DS.NTP.PRIM_NTP_SERV')}
                    disabled={pageDisabled || !managedInSmp}
                    value={primaryNtpServer}
                    onChange={e => setPageValue(pageSchema.primaryNtpServer, e.target.value)}
                />
                {/* Secondary NTP server */}
                <SMCTextInput
                    label={t('SMP.PLAN.NEW_PLAN_DS.NTP.SEC_NTP_SERV')}
                    disabled={pageDisabled || !managedInSmp}
                    value={secondaryNtpServer}
                    onChange={e => setPageValue(pageSchema.secondaryNtpServer, e.target.value)}
                />
                {/* Update interval */}
                <SMCNumberInput
                    label={t('SMP.PLAN.NEW_PLAN_DS.NTP.UPDATE_INTERVAL')}
                    disabled={pageDisabled || !managedInSmp}
                    value={updateInterval}
                    onChange={e => setPageValue(pageSchema.updateIntervalMinutes, parseInt(e.target.value))}
                />
                <SMCToggleSwitch
                    disabled={pageDisabled || !managedInSmp}
                    checked={isNTPAuth}
                    onChange={locked => setPageValue(pageSchema.ntpAuthentication, locked)}
                    label={t('SMP.PLAN.NEW_PLAN_DS.NTP.NTP_AUTH')}
                />
                <Indentation>
                    <SMCTextInput
                        label={t('SMP.PLAN.NEW_PLAN_DS.NTP.SHARED_SECRET')}
                        disabled={pageDisabled || !managedInSmp || !isNTPAuth}
                        value={sharedSecret}
                        onChange={e => setPageValue(pageSchema.sharedSecret, e.target.value)}
                    />
                    <SMCTextInput
                        label={t('SMP.PLAN.NEW_PLAN_DS.NTP.SHARED_SECRET_IDEN')}
                        disabled={pageDisabled || !managedInSmp || !isNTPAuth}
                        value={sharedSecretId}
                        onChange={e => setPageValue(pageSchema.sharedSecretIdentifier, e.target.value)}
                    />
                </Indentation>
            </PlanEditorInnerContainer>
        </EditorLayout>
    );
}

export default BaseNtp;